import React from 'react';
import copy from 'fast-copy';
import Switch from 'react-switch';
import { useTranslation } from 'react-i18next';
import { handlePromptScrollShadow, useStateWithCallback } from '../../../../Shared/utils';


const icon = (
  <svg viewBox="0 0 10 10" height="100%" width="100%" fill="#fff">
    <circle r={3.5} cx={5} cy={5} />
  </svg>
);



export default function Category({ isOpen = false, title, children,
  isReOrganizeMenu = false, subCategories = [], welcomeScreenManualInputs, sdsQuestions, scriptHeaders, mobileOthersData,
  nextColumns, setNextColumns
}) {

  const { t } = useTranslation();

  const setColumnHeader = (column) => {
    const [title, subtitle, extra, desc] = column.field.split('_$$_');

    // console.log("30 - column.field=", column.field);
    const isWelcomeScreenManualInput = column.field.length > 39 && (column.field.substring(0, 39) === "welcome_screen_$$_input_value_$$_input#");
    const isSdsQuestion = column.field.length > 45 && (column.field.substring(0, 45) === "questions_form_$$_question_value_$$_question#");
    const isScript = column.field.length > 33 && (column.field.substring(0, 33) === "script_$$_script_value_$$_script#");
    const isComments = column.field.length > 16 && (column.field.substring(0, 16) === "diag_comment_$$_");
    const isMobileOthersData = column.field.length > 17 && (column.field.substring(0, 17) === "other_mobiles_$$_");

    column.customHeaderName = false;
    column.disableReorder = true;

    if (isWelcomeScreenManualInput) {
      const strTmp = `${t(column.parentTitle)} \u2013 ${t(`reporting.columns.${title}.sub_title`)}`
      column.headerName = strTmp;
    }
    else if (isSdsQuestion) {
      const strTmp = `${t(column.parentTitle)} \u2013 ${t(`reporting.columns.${title}.sub_title`)}`
      column.headerName = strTmp;
    }
    else if (isScript) {
      column.headerName = `${t(`reporting.columns.${title}.sub_title`)}`;
    }
    else if (column.parentTitle) {
      column.headerName = `${t(column.parentTitle)} \u2013 ${t(`reporting.columns.${title}.sub_title`)} \u2013 ${t(`reporting.columns.${title}.${subtitle}`)}`
    }
    else if (isComments) {
      column.headerName = `${t(`reporting.columns.settings.diagnostics`)} \u2013 ${t(`reporting.columns.${subtitle}.sub_title`)}`;
    }
    else if (isMobileOthersData) {
      if (!extra) {
        column.headerName = `${t(`reporting.columns.${title}.sub_title`)} \u2013 ${t(`reporting.columns.${title}.${subtitle}`)}`
      }
      else {
        column.headerName = `${t(`reporting.columns.${title}.sub_title`)}`;
      }
    }
    else {
      column.headerName = `${t(`reporting.columns.${title}.sub_title`)} \u2013 ${t(`reporting.columns.${title}.${subtitle}`)}`
    }

    if (extra) {
      if (isWelcomeScreenManualInput) {
        const found = welcomeScreenManualInputs && welcomeScreenManualInputs.find((element) => {
          const strTest = element.xtra_id + '_$$_' + element.xtra_desc;
          return strTest === column.field.substring(39);     // String VS numeric...
        });

        if (found) {
          column.headerName = column.headerName + ` \u2013 ` + t(`reporting.columns.manual_input.input`) + ` #` + found.xtra_id + ' : ' + found.xtra_desc;
        }
        else {
          column.headerName = column.headerName + ` \u2013 ` + t(`reporting.columns.manual_input.input`) + ` #` + column.field.substring(39);
        }
      }
      else if (isSdsQuestion) {
        const found = sdsQuestions && sdsQuestions.find((element) => {

          const strTest = element.xtra_id + '_$$_' + element.xtra_desc;
          return strTest === column.field.substring(45);     // String VS numeric...
        });


        if (found) {
          column.headerName = column.headerName + ` \u2013 ` + t(`reporting.columns.manual_input.sds_questions`) + ` #` + found.xtra_id + ' : ' + found.xtra_desc;
        }
        else {
          column.headerName = column.headerName + ` \u2013 ` + t(`reporting.columns.manual_input.sds_questions`) + ` #` + column.field.substring(45);
        }
      }
      else if (isScript) {
        const found = scriptHeaders && scriptHeaders.find((element) => {
          return element === column.field.substring(33);     // String VS numeric...
        });

        if (found) {
          column.headerName = column.headerName + ` \u2013 ` + found;
        }
        else {
          column.headerName = column.headerName + ` \u2013 ` + column.field.substring(33);
        }
      }
      else if (isComments) {
        column.headerName = column.headerName + ` \u2013 ${t(`reporting.columns.${subtitle}.${extra}`)} ${t(`reporting.columns.diag_common.comments`)}`;
      }
      else if (isMobileOthersData) {
        column.headerName = column.headerName + ` \u2013 (${t(`reporting.columns.other_mobiles_others.sub_title`)}) \u2013 ` + extra;
      }
      else
        column.headerName = column.headerName + ` \u2013 ` + extra;
    }
  }

  const isColumnChecked = (column) => nextColumns && nextColumns.map(col => col.field).includes(column);

  const toggleAllColumns = (toCheck) => {
    if (toCheck === false) {

      const newColumns = nextColumns.filter(column => {

        const colId = column && column.field;
        const [category, col] = colId.split('_$$_');
        let keep = true;

        subCategories.map(subCategory => {
          const subTitle = subCategory[0];
          const columns = subCategory[1];

          columns.map(subCategoryColumn => {
            if (subTitle === category) {
              if (toCheck === false) {
                keep = (!isColumnChecked(colId));
              }
            }
          });
        });
        return keep;
      });
    
      setNextColumns(newColumns);
    }


    if (toCheck === true) {

      const newColumns = copy(nextColumns);

      subCategories.map(subCategory => {

        const subTitle = subCategory[0];
        const columns = subCategory[1];
        columns.map(column => {
          const colId = `${subTitle}_$$_${column}`;

          if (colId === "script_$$_script_value" && scriptHeaders) {

            scriptHeaders.map(script => {
              const newColId = colId + "_$$_script#" + script

              if (!isColumnChecked(newColId)) {
                const headerName = "";
                const tmpColumn = {
                  width: 250,
                  print: false,
                  field: newColId,
                  customHeaderName: false,
                  parentTitle: parentTitle || null,
                  headerName: headerName
                }
                setColumnHeader(tmpColumn);
                newColumns.push(tmpColumn);
              }
            });
          }

          else if (colId === "manual_input_$$_questions_form" && sdsQuestions) {

            return (
              sdsQuestions.sort(function (a, b) {
                if (a.xtra_id < b.xtra_id) {
                  return -1;
                }
                if (a.xtra_id > b.xtra_id) {
                  return 1;
                }
                return 0;
              }).map(question => {

                const newColId = colId + "_$$_Question#" + question.xtra_id

                if (!isColumnChecked(newColId)) {
                  const headerName = "";
                  const tmpColumn = {
                    width: 250,
                    print: false,
                    field: newColId,
                    customHeaderName: false,
                    parentTitle: parentTitle || null,
                    headerName: headerName
                  }
                  setColumnHeader(tmpColumn);
                  newColumns.push(tmpColumn);
                }
              })
            )
          }

          else if (colId === "questions_form_$$_question_value" && sdsQuestions) {

            return (
              sdsQuestions.sort(function (a, b) {
                if (a.xtra_id < b.xtra_id) {
                  return -1;
                }
                if (a.xtra_id > b.xtra_id) {
                  return 1;
                }
                return 0;
              }).map(question => {
                if (question.xtra_id !== null) {
                  const newColId = colId + "_$$_question#" + question.xtra_id + '_$$_' + question.xtra_desc;

                  if (!isColumnChecked(newColId)) {
                    const headerName = "";
                    const tmpColumn = {
                      width: 250,
                      print: false,
                      field: newColId,
                      customHeaderName: false,
                      parentTitle: parentTitle || null,
                      headerName: headerName
                    }
                    setColumnHeader(tmpColumn);
                    newColumns.push(tmpColumn);
                  }
                }
              })
            )
          }

          else if (colId === "welcome_screen_$$_input_value" && welcomeScreenManualInputs) {

            return (
              welcomeScreenManualInputs.sort(function (a, b) {
                if (a.xtra_id < b.xtra_id) {
                  return -1;
                }
                if (a.xtra_id > b.xtra_id) {
                  return 1;
                }
                return 0;
              }).map(question => {

                if (question.xtra_id !== null) {
                  const newColId = colId + "_$$_input#" + question.xtra_id + "_$$_" + question.xtra_desc;

                  if (!isColumnChecked(newColId)) {
                    const headerName = "";
                    const tmpColumn = {
                      width: 250,
                      print: false,
                      field: newColId,
                      customHeaderName: false,
                      parentTitle: parentTitle || null,
                      headerName: headerName
                    }
                    setColumnHeader(tmpColumn);
                    newColumns.push(tmpColumn);
                  }
                }
              })
            )
          }

          else if (colId === "other_mobiles_$$_others_input_value" && mobileOthersData) {

            return (
              mobileOthersData.sort(function (a, b) {
                if (a.xtra_id < b.xtra_id) {
                  return -1;
                }
                if (a.xtra_id > b.xtra_id) {
                  return 1;
                }
                return 0;
              }).map(data => {

                if (data !== null) {
                  const newColId = colId + "_$$_" + data;

                  if (!isColumnChecked(newColId)) {
                    const headerName = "";
                    const tmpColumn = {
                      width: 250,
                      print: false,
                      field: newColId,
                      customHeaderName: false,
                      parentTitle: parentTitle || null,
                      headerName: headerName
                    }
                    setColumnHeader(tmpColumn);
                    newColumns.push(tmpColumn);
                  }
                }
              })
            )
          }

          else {

            if (!isColumnChecked(colId)) {
              const headerName = "";
              const tmpColumn = {
                width: 250,
                print: false,
                field: colId,
                customHeaderName: false,
                parentTitle: parentTitle || null,
                headerName: headerName
              }
              setColumnHeader(tmpColumn);
              newColumns.push(tmpColumn);
            }
          }
        });

        setNextColumns(newColumns);
      })
    }
  };

  // Callback: update the prompt's bottom shadow when interacting with the categories
  const [open, setOpen] = useStateWithCallback(isOpen);

  const parentTitle = title;

  let allChecked = true;
  let noneChecked = true;
  subCategories.map(subCategory => {

    const subTitle = subCategory[0];
    const columns = subCategory[1];

    columns.map(column => {
      const colId = `${subTitle}_$$_${column}`;

      if (colId === "script_$$_script_value" && scriptHeaders) {
        scriptHeaders.map(script => {
          const newColId = colId + "_$$_script#" + script
          if (isColumnChecked(newColId))
            noneChecked = false;
          else
            allChecked = false;
        })
      }
      else if (colId === "manual_input_$$_questions_form" && sdsQuestions) {

        return (
          sdsQuestions.sort(function (a, b) {
            if (a.xtra_id < b.xtra_id) {
              return -1;
            }
            if (a.xtra_id > b.xtra_id) {
              return 1;
            }
            return 0;
          }).map(question => {
            const newColId = colId + "_$$_Question#" + question.xtra_id
            if (isColumnChecked(newColId))
              noneChecked = false;
            else
              allChecked = false;
          })
        )
      }

      else if (colId === "questions_form_$$_question_value" && sdsQuestions) {

        return (
          sdsQuestions.sort(function (a, b) {
            if (a.xtra_id < b.xtra_id) {
              return -1;
            }
            if (a.xtra_id > b.xtra_id) {
              return 1;
            }
            return 0;
          }).map(question => {

            if (question.xtra_id !== null) {
              const newColId = colId + "_$$_question#" + question.xtra_id + "_$$_" + question.xtra_desc;
              if (isColumnChecked(newColId))
                noneChecked = false;
              else
                allChecked = false;
            }
          })
        )
      }

      else if (colId === "welcome_screen_$$_input_value" && welcomeScreenManualInputs) {

        return (
          welcomeScreenManualInputs.sort(function (a, b) {
            if (a.xtra_id < b.xtra_id) {
              return -1;
            }
            if (a.xtra_id > b.xtra_id) {
              return 1;
            }
            return 0;
          }).map(question => {

            if (question.xtra_id !== null) {
              const newColId = colId + "_$$_input#" + question.xtra_id + "_$$_" + question.xtra_desc;
              if (isColumnChecked(newColId))
                noneChecked = false;
              else
                allChecked = false;
            }
          })
        )
      }

      else if (colId === "other_mobiles_$$_others_input_value" && mobileOthersData) {

        return (
          mobileOthersData.sort(function (a, b) {
            if (a.xtra_id < b.xtra_id) {
              return -1;
            }
            if (a.xtra_id > b.xtra_id) {
              return 1;
            }
            return 0;
          }).map(data => {

            if (data !== null) {
              const newColId = colId + "_$$_" + data;
              if (isColumnChecked(newColId))
                noneChecked = false;
              else
                allChecked = false;
            }
          })
        )
      }
      else {
        if (isColumnChecked(colId))
          noneChecked = false;
        else
          allChecked = false;
      }
    });
  })



  if (isReOrganizeMenu) {
  return (
    <div className={"category " + (open ? 'open' : 'closed')}>
      <div className="category__title" onClick={() => setOpen(!open, () => handlePromptScrollShadow())}>
        <h3>{title}</h3>
        <span className="material-icons">arrow_{open ? 'drop_down' : 'right'}</span>
      </div>

      {children}
    </div>
  );

  }
  else {
    return (
      <div className={"category " + (open ? 'open' : 'closed')}>
        <div className="category__title" onClick={() => setOpen(!open, () => handlePromptScrollShadow())}>
          <h3>{title}...</h3>

          <div
          >
            <span onClick={(e) => {
              e.stopPropagation();
              toggleAllColumns(!allChecked)
            }}>
              <Switch
                size="small"
                checked={allChecked}
                onChange={() => console.log("486...")}
                offHandleColor="#888" onHandleColor="#080"
                checkedHandleIcon={icon} uncheckedHandleIcon={icon}
              />
            </span>

            <span className="material-icons">arrow_{open ? 'drop_down' : 'right'}</span>
          </div>


          {/* <span className="material-icons">arrow_{open ? 'drop_down' : 'right'}</span> */}
        </div>

        {children}
      </div>
    );
  }
}
